module.exports = __webpack_public_path__ + "img/sentiment.6f167e0c.png";